var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signup-page row" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 p-1" }, [
          _c("div", { staticClass: "bg-white p-3" }, [
            _c("div", { staticClass: "d-flex my-2" }, [
              _vm._m(0),
              _c("div", [
                _c("h2", { staticClass: "purchase-page-main-header" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")("st_public.get_instance_information_on")
                    ) + " "
                  ),
                  _c(
                    "b",
                    {
                      staticClass: "d-inline-block",
                      staticStyle: { direction: "ltr" }
                    },
                    [_vm._v(_vm._s(_vm.lastSearchText))]
                  )
                ]),
                _c("div", {
                  staticClass: "purchase-page-sub-header",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$root.trans(
                        "st_public.your_purchase_is_confidential",
                        { phone: _vm.lastSearchText }
                      )
                    )
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-6 p-1" }, [
              _c("div", { staticClass: "bg-white p-3" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "d-inline-block ml-3" }, [
                    _c("div", { staticClass: "info-header" }, [
                      _vm._v(
                        _vm._s(_vm._f("trans")("st_public.results_are_ready"))
                      )
                    ]),
                    _c(
                      "h1",
                      {
                        staticStyle: {
                          padding: "0",
                          "font-size": "18px",
                          "font-weight": "bold",
                          "margin-bottom": "0",
                          direction: "ltr"
                        }
                      },
                      [_vm._v(_vm._s(_vm.lastSearchText))]
                    ),
                    _c("small", { staticClass: "mt-2 d-block" }, [
                      _vm._v(
                        "\n                                        " +
                          _vm._s(
                            _vm._f("trans")("st_public.latest_report_as_of")
                          ) +
                          " "
                      ),
                      _c("b", [
                        _c("span", { staticClass: "text-success" }, [
                          _vm._v(
                            _vm._s(new Date().getFullYear()) +
                              "-" +
                              _vm._s(new Date().getMonth() + 1) +
                              "-" +
                              _vm._s(new Date().getDate())
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "bg-secondary mt-4 purchase-preview-map-container"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "purchase-preview-may-includes-block d-block p-2"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "my-2" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")("st_public.may_includes")
                                  )
                                )
                              ])
                            ]),
                            _c("hr")
                          ])
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-5 purchase-check-list-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.owners_full_name")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-7 purchase-check-list-action" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _vm._m(2),
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "lang-signup",
                                          params: { lang: this.lang }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.see_owner_full_name"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-5 purchase-check-list-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.current_address")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-7 purchase-check-list-action" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _vm._m(3),
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "lang-signup",
                                          params: { lang: this.lang }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.see_full_address"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-5 purchase-check-list-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.current_location")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-7 purchase-check-list-action" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _vm._m(4),
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "lang-signup",
                                          params: { lang: this.lang }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.currentAddress) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-5 purchase-check-list-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.family_members")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-7 purchase-check-list-action" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _vm._m(5),
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "lang-signup",
                                          params: { lang: this.lang }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.see_available_results"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-5 purchase-check-list-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.address_history")
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-7 purchase-check-list-action" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _vm._m(6),
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "lang-signup",
                                          params: { lang: this.lang }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f(
                                            "trans"
                                          )("st_public.addresses_found", {
                                            counter: _vm.addressesCount
                                          })
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-5 purchase-check-list-label" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("trans")("st_public.phone_type"))
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-7 purchase-check-list-action" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _vm._m(7),
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "lang-signup",
                                          params: { lang: this.lang }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.see_available_results"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _c("div", { staticClass: "mt-4" }, [
                  _c("span", { staticClass: "text-danger mr-2" }, [
                    _vm._v(_vm._s(_vm._f("trans")("st_public.caution")))
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("trans")("st_public.caution_text")))
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-6 p-1" }, [
              _c("div", { staticClass: "banner-option px-3" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm._f("trans")("st_public.pick_your_option")) +
                    "\n                        "
                )
              ]),
              _c(
                "div",
                { staticClass: "bg-white p-3" },
                [
                  _c(
                    "nuxt-link",
                    {
                      attrs: {
                        to: { name: "lang-signup", params: { lang: this.lang } }
                      }
                    },
                    [
                      _c("div", { staticClass: "special-plan-title" }, [
                        _c("span", { staticClass: "fa fa-file" }),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm._f("trans")("st_public.full phone report")
                            ) +
                            "\n                                "
                        )
                      ]),
                      _c("div", { staticClass: "special-plan-price" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.paymentPackageSettings.display_trial_price
                            )
                          )
                        ]),
                        _c("span", { staticClass: "currency" }, [
                          _vm._v(_vm._s(_vm.displayCurrency))
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm._f("trans")("st_public.special price")) +
                            "\n                                "
                        )
                      ]),
                      _c("div", { staticClass: "special-plan-intro" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.special offer with membership gives you:"
                              )
                            ) +
                            "\n                                "
                        )
                      ]),
                      _c("ul", { staticClass: "special-plan-list" }, [
                        _c("li", { staticClass: "special-plan-item" }, [
                          _c("div", { staticClass: "special-plan-item-icon" }, [
                            _c("i", { staticClass: "fa fa-check" })
                          ]),
                          _c(
                            "div",
                            { staticClass: "special-plan-item-content" },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.full access to phone search"
                                    )
                                  ) +
                                  "\n                                        "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "special-plan-item-sub-content" },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.purchase page find people content"
                                    )
                                  ) +
                                  "\n                                        "
                              )
                            ]
                          )
                        ]),
                        _c("li", { staticClass: "special-plan-item" }, [
                          _c("div", { staticClass: "special-plan-item-icon" }, [
                            _c("i", { staticClass: "fa fa-check" })
                          ]),
                          _c(
                            "div",
                            { staticClass: "special-plan-item-content" },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.purchase page instant access message"
                                    )
                                  ) +
                                  "\n                                        "
                              )
                            ]
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "special-plan-continue btn btn-success"
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm._f("trans")("st_public.continue")) +
                              " \n                                    "
                          ),
                          _vm.lang == "ar"
                            ? _c("span", {
                                staticClass: "fa fa-arrow-circle-left"
                              })
                            : _c("span", {
                                staticClass: "fa fa-arrow-circle-right"
                              })
                        ]
                      ),
                      _c("div", { staticClass: "special-plan-discount" }, [
                        _c("span", [_vm._v("51%")]),
                        _c("br"),
                        _vm._v(" OFF")
                      ]),
                      _c("div", { staticClass: "special-plan-title" }, [
                        _c("span", { staticClass: "fa fa-file" }),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm._f("trans")("st_public.full phone report")
                            ) +
                            "\n                                "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "bg-white p-3 mt-2" },
                [
                  _c("div", [
                    _c("div", { staticClass: "d-block info-header" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")("st_public.your_satisfaction_title")
                        )
                      )
                    ]),
                    _c("div", { staticClass: "d-flex info-body pt-3" }, [
                      _vm._m(8),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.your_satisfaction_message"
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _c("hr"),
                  _c("featured-on")
                ],
                1
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "h1 pr-3" }, [
      _c("span", { staticClass: "fa fa-check-circle text-success d-block" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block" }, [
      _c("div", { staticClass: "bg-light px-4 py-3 position-relative" }, [
        _c("span", {
          staticClass: "fa fa-user",
          staticStyle: { "font-size": "40px", color: "#bec1c7" }
        }),
        _c("div", {
          staticClass: "fa fa-lock text-white",
          staticStyle: {
            "font-size": "14px",
            padding: "5px 8px",
            position: "absolute",
            bottom: "-6px",
            right: "-6px",
            "background-color": "#bec1c7",
            border: "2px solid #fff",
            "border-radius": "50px"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "fa fa-check text-success mr-2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "fa fa-check text-success mr-2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "fa fa-check text-success mr-2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "fa fa-check text-success mr-2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "fa fa-check text-success mr-2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "fa fa-check text-success mr-2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mr-2" }, [
      _c("img", { attrs: { src: require("assets/img//best-value.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a2f26b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a2f26b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/purchase-preview.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1a2f26b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/purchase-preview.vue
// module chunks = 11